module.exports = __webpack_public_path__ + "img/T605.e6c2d27c.jpg";